import { getStorage } from '../../../../../home24/helpers/storage-factory';
import { classNames } from '../../constants/recommendations';

const trackingDataAttrsMap = {
  sku: 'data-sku',
  position: 'data-position',
  recommendationId: 'data-recommendation-id'
};
const storageKey = 'GtmOnArticleClicked';

const getElemByClassName = cn => document.querySelector(`.${cn}`);

const getTrackingData = target => {
  const data = Object.keys(trackingDataAttrsMap).reduce(
    (attr, key) => ({
      ...attr,
      [key]: target.getAttribute(trackingDataAttrsMap[key])
    }),
    {}
  );
  data.source = getElemByClassName(classNames.SLIDER_CONTAINER).getAttribute(
    'data-gtm-event-source'
  );
  return data;
};

const storeTrackingData = data => {
  const storage = getStorage();
  storage.set(storageKey, data);
};

const handleRecommendationClick = ({ currentTarget }) => {
  const trackingData = getTrackingData(currentTarget);
  storeTrackingData(trackingData);
};

export const attachInhouseRecommendationsTracking = () => {
  const recNodes = Array.from(
    document.querySelectorAll(
      `.${classNames.SLIDER_CONTAINER} [data-gtm-bind-click]`
    )
  );

  for (const recNode of Array.from(recNodes)) {
    recNode.addEventListener('click', handleRecommendationClick);
  }
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/functions/eventListeners/recommendations.js
 **/